import classnames from "classnames";
import { createElement, ReactNode } from "react";
import styles from "./paText.module.scss";

interface Props {
  component?: string;
  fontSize?: string;
  color?: "medium-grey" | "success-primary" | "grey" | "light-black" | "light-grey" |
  "pa-blue" | "black" | "success-secondary" | "white" | "alert-text" | "alert-secondary"
  | "success-green" | "pink" | "grey-secondary";
  className?: string;
  bold?: boolean;
  link?: boolean;
  underline?: boolean;
  children: ReactNode;
  onClick?: () => void;
  inlineBlock?: boolean;
  centerAlign?: boolean;
  title?: string;
}

export const FONT_SIZE = [
  "xs", // 14px
  "sm", // 16px
  "md", // 18px
  "lg", // 20px
  "xl", // 22px
  "xxl", // 24px
  "xxs", // 12px
];

const headTags = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
];

export default function PAText(props: Props) {
  const {
    component = "span", fontSize = !headTags.includes(component) ? "sm" : "", color = "", className = "", children,
    bold, underline, link, inlineBlock, centerAlign, ...rest
  } = props;
  return createElement(
    component,
    {
      className: classnames({
        [styles[fontSize]]: !!fontSize,
        [styles.bold]: bold,
        [styles.link]: link,
        [styles.underline]: underline,
        [styles.inlineBlock]: inlineBlock,
        [styles.center_align]: centerAlign,
      }, className, [styles[color]]),
      ...rest,
    },
    children,
  );
}
